import { SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const NotesAndAssumptionForm = _ref => {
  let {
    loading,
    categories,
    onSubmit
  } = _ref;
  const {
    t
  } = useTranslation();
  const [form, setForm] = useState({
    comments: '',
    expenditure_category: ''
  });
  const allFieldsFilled = form.comments.trim() !== '' && form.expenditure_category.trim() !== '';
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setForm({
      ...form,
      [name]: value
    });
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (!allFieldsFilled) return;
    if (onSubmit) await onSubmit(form);
    setForm({
      comments: '',
      expenditure_category: ''
    });
  };
  const getCategoryLabel = category => {
    return t(category);
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    className: "p-3 border rounded mb-4 bg-light"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "expenditure_category",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('category')), /*#__PURE__*/React.createElement(Form.Select, {
    name: "expenditure_category",
    value: form.expenditure_category,
    onChange: handleChange,
    required: true
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, t('select_category')), categories.map(category => /*#__PURE__*/React.createElement("option", {
    key: category,
    value: category
  }, getCategoryLabel(category))))), /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "comments",
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('comments')), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    rows: 4,
    name: "comments",
    value: form.comments,
    onChange: handleChange,
    placeholder: t('enter_comments'),
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-end"
  }, /*#__PURE__*/React.createElement(SaveButton, {
    disabled: !allFieldsFilled || loading,
    text: loading ? t('creating') : t('create')
  })));
};
export default NotesAndAssumptionForm;